/* GEM brand homepage motion: scroll reveals, staggered tiles, hero parallax. */
(function () {
  if (window.__gmxMotion) return;
  window.__gmxMotion = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { root.classList.add('gmx-rm'); return; }
  root.classList.add('gmx-js');

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;

  var pending = [];
  function add(el, delay) {
    if (!el || el.classList.contains('gmx-rv')) return;
    if (delay) el.style.setProperty('--gmx-d', delay + 'ms');
    el.classList.add('gmx-rv');
    pending.push(el);
    if (io) io.observe(el); else el.classList.add('is-in');
  }

  function prep(scope) {
    var q = function (s) { return Array.prototype.slice.call(scope.querySelectorAll(s)); };
    q('.gmx-head, .gmx-finder__box, .gmx-cta__row, .gmx-feature__media, .gmx-feature .gmx-split > div:last-child').forEach(function (el) { add(el, 0); });
    q('.gmx-grid, .gmx-promo, .gmx-mosaic, .gmx-steps').forEach(function (g) {
      Array.prototype.slice.call(g.children).forEach(function (c, i) { add(c, (i % 8) * 90); });
    });
  }

  /* Fallback for browsers or tabs where the observer is slow to fire. */
  function sweep() {
    var h = window.innerHeight || 800;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.95) { el.classList.add('is-in'); return false; }
      return true;
    });
  }

  /* Hero parallax: the photo drifts slower than the page. */
  var heroes = [];
  var ticking = false;
  function parallax() {
    ticking = false;
    var h = window.innerHeight || 800;
    heroes.forEach(function (m) {
      var r = m.parentNode.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      m.style.transform = 'translate3d(0,' + Math.round(-r.top * 0.25) + 'px,0)';
    });
  }
  function onScroll() {
    sweep();
    if (!ticking) { ticking = true; window.requestAnimationFrame(parallax); }
  }

  function init(scope) {
    prep(scope || document);
    heroes = Array.prototype.slice.call(document.querySelectorAll('.gmx-hero__media'));
    parallax();
    setTimeout(sweep, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  /* Theme editor: re-run when a section is added or changed. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
